import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/common/ui/Button";
import { history } from "../../_helpers";
import { PODAction } from "../../_store/pod.slice";
import {
  authActions,
  inmateAction,
  IpActivityAction,
  masterActions,
} from "../../_store";
import podSchema from "../../validation/podSchema";
import { useLocation } from "react-router-dom";
import Table from "../../components/common/table/Table";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import generateXlsx from "../../components/common/export/generateXlsx";
import CustomLoader from "../../components/common/ui/Loader";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { formatDateTimeAMPM } from "../../utils/formatTime";
const DEFAULT_PAGE_NO = 1;
const DEFAULT_ROW_COUNT_PER_PAGE = 10;
function IPDetails() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location; // Destructure state from location
  const ipAddressState = location?.state?.ipAddressState; // Use optional chaining to prevent errors if state is undefined
  const FacilityId = location?.state?.FacilityID;

  const {
    inmateConnectionLoading,
    inmateConnectionList,
    inmateConnectionFullList,
    getipAddressPUFulllist,
    getipAddressPUlist,
    ipAddressPUlistloading,
    IpActivityPivotList,
  } = useSelector((state) => state.ipActivity);

  const user = useSelector((x) => x.auth.user);

  const shouldShowExcelExport = getipAddressPUlist?.TotalRecordCount;

  const [ipActivityInput, setipActivityInput] = useState({
    IpAddress: ipAddressState?.IPAddress,
    FlagName: ipAddressState?.FlagName,
    FacilityID: FacilityId,
    PageNo: DEFAULT_PAGE_NO,
    RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
    SortField: "",
  });

  useEffect(() => {
    setipActivityInput((prevState) => ({
      ...prevState,
      IpAddress: location?.state?.ipAddressState?.IPAddress,
      FlagName: location?.state?.ipAddressState?.FlagName,
      RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
      PageNo: DEFAULT_PAGE_NO,
    }));
  }, [location?.state?.ipAddressState]);

  // Column configuration for the table
  const columns = useMemo(() => [
    {
      name: "User Name",
      key: "UserName",
      selector: (row) => row.UserName,
      sortable: true,
    },
    {
      name: "Last Name",
      key: "LastName",
      selector: (row) => row.LastName,
      sortable: true,
    },
    {
      name: "First Name",
      key: "FirstName",
      selector: (row) => row.FirstName,
      sortable: true,
    },
    {
      name: "Email",
      key: "Email",
      selector: (row) => row.Email,
      sortable: true,
    },
    {
      name: "Connection Count",
      key: "ConnectionCount",
      selector: (row) => row.ConnectionCount,
      sortable: true,
      cell: (row) =>
        row.ConnectionCount > 0 ? (
          <div
            onClick={() => navigateToIPDetails(row)}
            data-bs-toggle="modal"
            data-bs-target="#PBConnectionDetails"
            className="Common_Link_Style"
          >
            {row.ConnectionCount}
          </div>
        ) : (
          <span style={{ cursor: "not-allowed" }}>{row.ConnectionCount}</span>
        ),
      center: true,
    },

    {
      name: "Last Login On",
      key: "LastLoginDate",
      selector: (row) => formatDateTimeAMPM(row.LastLoginDate),
      sortable: true,
    },
  ]);

  // Column configuration for the table
  const Connectioncolumns = useMemo(() => [
    {
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      sortable: true,
    },
    {
      name: "Inmate Name",
      key: "InmateName",
      selector: (row) => row.InmateName,
      sortable: true,
    },
    {
      name: "Facility",
      key: "FacilityName",
      selector: (row) => row.FacilityName,
      sortable: true,
    },
    {
      name: "Inmate Status",
      key: "InmateCurrentStatus",
      selector: (row) => row.InmateCurrentStatus,
      sortable: true,
    },
    {
      width: '120px',
      name: "Relationship",
      key: "RelationShip",
      selector: (row) => row.RelationShip,
      sortable: true,
    },
    {
      name: "Connection Status",
      key: "ConnectionStatus",
      selector: (row) => row.ConnectionStatus,
      sortable: true,
    },
  ]);

  // Dynamically generate columns based on keys
  const PUcolumns = useMemo(() => {
    if (IpActivityPivotList.length === 0) return [];

    const keys = Object.keys(IpActivityPivotList[0]).filter(
      (key) => key !== "TotalPublicUsersMapped" // Exclude the "TotalPublicUsersMapped" column
    );
    return keys.map((key) => ({
      name: key === "Name" ? "Inmate Info" : key, // Rename "Name" column
      selector: (row) => row[key],
      sortable: true,
      cell: (row) => (
        <span>
          {key === "Name" ? (
            <div
              className="Common_Link_Style"
              onClick={() => handleNavigateToInmate(row)}
            >
              {row[key]}
            </div> // Make "Inmate Info" a clickable link
          ) : (
            row[key]
          )}
        </span>
      ),
    }));
  }, [IpActivityPivotList]);

  function extractNumber(input) {
    const match = input.match(/^(\d+)-/);
    return match ? match[1] : null;
  }

  const handleNavigateToInmate = (row) => {
    const result = extractNumber(row?.Name);
    const requestBody = {
      inmateResidentID: result,
      userFirstName: "",
      userLastName: "",
      facilityID: location?.state?.FacilityID,
      podID: 0,
      inmatesGender: 0,
      dobStartDate: "",
      dobEndDate: "",
      kiosksAccess: 2,
      activeStatus: 2,
      pageNo: 1,
      rowCountPerPage: 10,
      sortField: "",
    };
    dispatch(inmateAction.LoadInmatesSearch(requestBody)).then((x) => {
      if (x?.payload?.DataList?.length > 0) {
        dispatch(
          authActions?.updateCommonFacilityCode(
            location?.state?.FacilityID || x?.payload?.DataList[0]?.facilityID
          )
        );

        history.navigate("InmateList/Details", {
          state: {
            inmate: x?.payload?.DataList[0],
            source: "IpActivity",
            ipAddressState: location?.state?.ipAddressState,
            FacilityId: location?.state?.FacilityID,
            showTransactionTab: false,
          },
        });
      }
    });
  };
  //

  // Dispatch the action when FacilityID changes in loadManagementUser
  const [username, setUsername] = useState("");
  const [connectionDetails, setConnectionDetails] = useState({
    PublicUserID: 0,
    FacilityID: 0,
    ManagementUserID: 0,
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "",
  });

  useEffect(() => {
    dispatch(
      IpActivityAction.LoadIPAddressBasedPUDetails({
        ...ipActivityInput,
        FacilityID: ipActivityInput?.FacilityID || location?.state?.FacilityID,
        FlagName:
          ipActivityInput?.FlagName ||
          location?.state?.ipAddressState?.FlagName,
        IpAddress:
          ipActivityInput?.IpAddress ||
          location?.state?.ipAddressState?.IPAddress,
      })
    );
    dispatch(
      IpActivityAction.LoadPublicUserIPActivityPIVOT({
        ipAddressState:
          ipActivityInput.IpAddress ||
          location?.state?.ipAddressState?.IPAddress,
        FacilityId: ipActivityInput.FacilityID || location?.state?.FacilityID,
      })
    );
  }, [
    ipActivityInput?.RowCountPerPage,
    ipActivityInput?.PageNo,
    location?.state?.ipAddressState,
    FacilityId,
    ipAddressState,
  ]);

  useEffect(() => {
    dispatch(
      IpActivityAction.LoadIPActivityPublicInmateConnectionDetails({
        ...connectionDetails,
        FacilityID:
          connectionDetails?.FacilityID || location?.state?.FacilityID,
      })
    );
  }, [
    connectionDetails.PageNo,
    connectionDetails.RowCountPerPage,
    location?.state?.FacilityID,
    FacilityId,
    ipAddressState,
  ]);

  // Function to handle the selection of a POD code and navigate to the Edit page

  const navigateToIPDetails = (row) => {
    setUsername(row.UserName);
    let params = {
      PublicUserID: row.PublicUserID,
      FacilityID: ipActivityInput?.FacilityID || 0,
      ManagementUserID: user?.ManagementUserID || 0,
      PageNo: 1,
      RowCountPerPage: 10,
      SortField: "",
    };
    setConnectionDetails(params);
    dispatch(
      IpActivityAction.LoadIPActivityPublicInmateConnectionDetails(params)
    );
  };
  // Function to export POD data into an Excel file with specified columns and formatting.

  useEffect(() => {
    if (getipAddressPUFulllist?.DataList?.length > 0) {
      // Define the title of the Excel sheet
      const title = "IPAddressBasedonPublicUserList";

      // Define the column headers for Excel
      const generateExcelColumns = [
        "Username",
        "Last Name",
        "First Name",
        "E-mail",
        "Connection Count",
        "Last Login On",
      ];

      // Map the data for Excel
      const docList = getipAddressPUFulllist?.DataList?.map((obj) => ({
        Username: obj.UserName,
        LastName: obj.LastName,
        FirstName: obj.FirstName,
        Email: obj.Email,
        ConnectionCount: obj.ConnectionCount,
        LastLoginOn: formatDateTimeAMPM(obj.LastLoginDate),
      }));

      // Check if there is data before generating the Excel
      try {
        generateXlsx(docList, generateExcelColumns, title);
        dispatch(IpActivityAction.cleargetipAddressPUFulllist());
      } catch (error) {
        showToastNotification("Error", "error");
      }
    }
  }, [getipAddressPUFulllist]);

  const exportPODDataToExcel = () => {
    const updateTotalRows = {
      ...ipActivityInput,
      RowCountPerPage: getipAddressPUlist?.TotalRecordCount,
      exportExcel: true,
      PageNo: 1,
    };

    // Dispatch and process the response
    dispatch(IpActivityAction?.LoadIPAddressBasedPUDetails(updateTotalRows));
  };

  //Export Connection Details

  useEffect(() => {
    if (inmateConnectionFullList?.DataList?.length > 0) {
      // Define the title of the Excel sheet
      const title = "PublicUserConnectionList";

      // Define the column headers for Excel
      const generateExcelColumns = [
        "Inmate ID",
        "Inmate Name",
        "Facility",
        "Inmate Status",
        "RelationShip",
        "Connection Status",
      ];

      // Map the data for Excel
      const docList = inmateConnectionFullList?.DataList?.map((obj) => ({
        InmateID: obj.InmateResidentId,
        InmateName: obj.InmateName,
        FacilityName: obj.FacilityName,
        InmateCurrentStatus: obj.InmateCurrentStatus,
        RelationShip: obj.RelationShip,
        ConnectionStatus: obj.ConnectionStatus,
      }));

      // Check if there is data before generating the Excel
      try {
        generateXlsx(docList, generateExcelColumns, title);
        dispatch(IpActivityAction.clearinmateConnectionFullList());
      } catch (error) {
        showToastNotification("Error", "error");
      }
    }
  }, [inmateConnectionFullList]);

  const exportConnectionDetails = () => {
    const updateTotalRows = {
      ...connectionDetails,
      RowCountPerPage: inmateConnectionList?.TotalRecordCount,
      exportExcel: true,
      PageNo: 1,
    };

    // Dispatch and process the response
    dispatch(
      IpActivityAction?.LoadIPActivityPublicInmateConnectionDetails(
        updateTotalRows
      )
    );
  };

  //sorting
  let isSorting = false; // to restrict the pagination issue
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;

    isSorting = true;
    const search = { ...ipActivityInput };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    setipActivityInput(search);
    dispatch(
      IpActivityAction.LoadIPAddressBasedPUDetails({
        ...ipActivityInput,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
    // dispatch(
    //   IpActivityAction.LoadPublicUserIPActivityPIVOT({
    //     ipAddressState: ipActivityInput.IpAddress,
    //     FacilityId: ipActivityInput.FacilityID || location?.state?.FacilityID,
    //   })
    // );
  };

  //Modal sorting
  let isModalSorting = false; // to restrict the pagination issue
  const handleModalSort = (column, sortDirection) => {
    if (!column?.key) return;

    isModalSorting = true;
    const search = { ...connectionDetails };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    setConnectionDetails(search);
    dispatch(
      IpActivityAction.LoadIPActivityPublicInmateConnectionDetails({
        ...connectionDetails,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  // Updates the number of rows per page in the POD list data
  const handleRowCountChange = (newRowCount, name) => {
    if (name === "ipAddress") {
      setipActivityInput((prevState) => ({
        ...prevState,
        PageNo: DEFAULT_PAGE_NO,
        RowCountPerPage: newRowCount,
      }));
    } else if (name === "connection") {
      setConnectionDetails((prevState) => ({
        ...prevState,
        PageNo: DEFAULT_PAGE_NO,
        RowCountPerPage: newRowCount,
      }));
    }
  };

  // Handles page change for the POD list
  const handlePageChange = (newPage, name) => {
    if (name === "ipAddress") {
      if (isSorting) {
        isSorting = false;
        return;
      }
      setipActivityInput((prevState) => ({
        ...prevState,
        PageNo: newPage,
      }));
    } else if (name === "connection") {
      if (isModalSorting) {
        isModalSorting = false;
        return;
      }
      setConnectionDetails((prevState) => ({
        ...prevState,
        PageNo: newPage,
      }));
    }
  };

  if (ipAddressPUlistloading) {
    return <CustomLoader />;
  }
  return (
    <div>

      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
        <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100">
          <div className="d-flex flex-wrap justify-content-between align-items-center  mt-2 resp-space">
            <h2 className="form_title_uppercase text-color ip-title">
              IP Address Based On Public User List - {ipAddressState?.IPAddress}{" "}
            </h2>
            <div className="d-flex flex-wrap gap-3 align-items-center">
              <Button
                label="Back"
                type="button"
                className={"flex-shrink-0"}
                status="primary"
                icon={"fa-solid fa-angle-left"}
                onClick={() => {
                  history.navigate("IPActivityList");
                }}
              />
            </div>
          </div>
          <div className="d-flex flex-wrap justify-content-between align-items-center p-3">
            <div className="d-flex flex-wrap gap-3 align-items-center"></div>
            {shouldShowExcelExport && (
              <ExcelExport
                variant="soft-gray"
                handleExcelExport={exportPODDataToExcel}
              />
            )}
          </div>
          <div>
            <Table
              columns={columns}
              data={getipAddressPUlist?.DataList}
              pagination
              onChangeRowsPerPage={(value) =>
                handleRowCountChange(value, "ipAddress")
              }
              onChangePage={(value) => handlePageChange(value, "ipAddress")}
              totalRowCount={getipAddressPUlist?.TotalRecordCount}
              currentPage={ipActivityInput?.PageNo}
              paginationPerPage={ipActivityInput.RowCountPerPage}
              serverSideSort
              onSort={handleSort}
              sortColumn={ipActivityInput?.SortField?.split(" ")[0]}
              sortDirection={ipActivityInput?.SortField?.split(" ")[1]}
            />
          </div>
        </div>

        <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100 mb-4">
          <div className="d-flex flex-wrap row align-items-center">
            <div className="col-md-11 mb-3">
              <h2
                className="form_title_uppercase text-color"
              >
                Public User - IP Activity{" "}
                <span>
                  <i
                    title="Inmates who have at least two or more common connection with the public user and the public user who has at least one connection with any inmate,accessing the same IP Address will be displayed in grid."
                    className="fs-4 fa fa-info-circle"
                    aria-hidden="true"
                  ></i>
                </span>{" "}
              </h2>
            </div>
            <div className="col-md-1"></div>
            {IpActivityPivotList.length === 0 ? (
              <div className="text-center">
                <b className="table-no-data-text mt-5 fs-4 mb-5">
                  No Common Connections
                </b>
              </div>
            ) : (
              <>
                <Table columns={PUcolumns} data={IpActivityPivotList} />
              </>
            )}
          </div>
          <br />
          <div>
            <CommonModal
              modalId="PBConnectionDetails"
              title="Public User Connection Details"
              loader={inmateConnectionLoading}
              bodyContent={
                <>
                  <div className="d-flex flex-wrap align-items-center gap-3 mb-2">
                    <div className="d-flex flex-wrap align-items-center">
                      <span className="ms-2">Username : {username}</span>
                    </div>
                    <div className="ms-auto">
                      <ExcelExport
                        variant="soft-gray"
                        handleExcelExport={exportConnectionDetails}
                      />
                    </div>
                  </div>
                  <Table
                    columns={Connectioncolumns}
                    data={inmateConnectionList?.DataList}
                    pagination
                    onChangeRowsPerPage={(value) =>
                      handleRowCountChange(value, "connection")
                    }
                    onChangePage={(value) =>
                      handlePageChange(value, "connection")
                    }
                    totalRowCount={inmateConnectionList?.TotalRecordCount}
                    currentPage={connectionDetails?.PageNo}
                    paginationPerPage={connectionDetails.RowCountPerPage}
                    serverSideSort
                    onSort={handleModalSort}
                    sortColumn={connectionDetails?.SortField?.split(" ")[0]}
                    sortDirection={connectionDetails?.SortField?.split(" ")[1]}
                  />
                </>
              }
              footerContent={
                <button
                  className="btn button-primary"
                  data-bs-dismiss="modal"
                // onClick={handleCloseModal}
                >
                  Close
                </button>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(IPDetails);
